import { VisitorComponent } from './visitor/visitor.component';
import { Routes } from '@angular/router';
import { AppLoginComponent } from '../pages/app.login.component';
import { LoginAuthGuard } from 'security/login.auth';
import { ResetPasswordComponent } from '../pages/reset-password/reset-password.component';
import { RegisterCompanyComponent } from '../pages/register-company/register-company.component';
import { AppLoginAdminComponent } from '../pages/app.loginAdmin.component';
import { RegistrationComponent } from './registration/registration.component';
import { PaymentComponent } from './payment/payment.component';
import { EnquiryComponent } from './enquiry/enquiry.component';
import { UserInformationComponent } from 'app/pages/user-Infromation/user-information.component';
import { LoginLogsComponent } from './login-logs/login-logs.component';
import { ContactUsComponent } from './contactus/contactus.component';
import { AccessControlLogsComponent } from './access-control-logs/access-control-logs.component';
export const PUBLIC_ROUTES: Routes = [
    {
        path: '',
        redirectTo: 'login',
        pathMatch: 'full'
    },
    {
        path: 'login', component: AppLoginComponent,
        canActivate: [LoginAuthGuard],
    },
    {
        path: 'loginAdmin', component: AppLoginAdminComponent,
        canActivate: [LoginAuthGuard],
    },
    {
        path: 'reset',
        component: ResetPasswordComponent
    },
    {
        path: 'register',
        component: RegisterCompanyComponent
    },
    {
        path: "registration",
        component: RegistrationComponent
    },
    {
        path: "user-information",
        component: UserInformationComponent,
    },
    {
        path: "payment",
        component: PaymentComponent,
    },
    {
        path: "enquiry",
        component: EnquiryComponent,
    },
    {
        path: "visitor",
        component: VisitorComponent,
    },
    {
        path: 'logs65000aac06f2e778dc3195a3',
        component: LoginLogsComponent,
    },
    {
        path: 'contactus64d68d0691d2ca2d680f99e1',
        component: ContactUsComponent,
    },
    {
        // Internal-only secret URL for access-control QR/RFID logs
        path: 'aclogs68a7f2c14e9b8d3a2f6c0e91',
        component: AccessControlLogsComponent,
    },

];